import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IGetPropertyListPayload} from "../types/GetPropertyListPayload";

export const propertyListConstraints: IGetPropertyListPayload = {
    display_type: OfferDisplayType.FOR_SALE,
    for_sale: true,
    limited_presentation: false,
    show_on_listing: true
};
import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IGetPropertyListPayload} from "../types/GetPropertyListPayload";

export const propertyListConstraints: IGetPropertyListPayload = {
    display_type: OfferDisplayType.FOR_SALE,
    for_sale: true,
    limited_presentation: false,
    show_on_listing: true
};
